import { render, staticRenderFns } from "./login-phone.vue?vue&type=template&id=48a92f4c&scoped=true&"
import script from "./login-phone.vue?vue&type=script&lang=js&"
export * from "./login-phone.vue?vue&type=script&lang=js&"
import style0 from "./login-phone.vue?vue&type=style&index=0&id=48a92f4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a92f4c",
  null
  
)

export default component.exports